import React from 'react';
import { H4 } from '~typography';
import Container from './Container';
import ContentContainer from './ContentContainer';

var ProductDetails = function ProductDetails(_ref) {
  var title = _ref.title,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(H4, {
    isUppercase: true
  }, title), /*#__PURE__*/React.createElement(ContentContainer, null, children));
};

ProductDetails.defaultProps = {};
export default ProductDetails;